import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { partnerApi } from "../../../services/partnerApi";
import OnboardingStepFrame from "../../../components/instructor/OnboardingStepFrame";

const inputClass =
  "mt-1.5 w-full rounded-lg border border-emerald-200 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm focus:outline-none focus:border-emerald-600 focus:ring-2 focus:ring-emerald-600/20";
const labelClass = "text-sm font-medium text-gray-900";
const sectionClass =
  "rounded-2xl border border-emerald-100/90 bg-white/90 p-5 shadow-sm sm:p-6 space-y-4";

export default function PartnerSourceStep() {
  const { partner, refreshPartner } = useAuth();
  const navigate = useNavigate();
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const primary = partner?.sources?.[0];
    if (primary) {
      setWebsiteUrl(primary.website_url || "");
    } else if (partner?.org?.website) {
      setWebsiteUrl(partner.org.website);
    }
  }, [partner]);

  async function handleSave(e) {
    e.preventDefault();
    setError("");
    setSaving(true);
    try {
      await partnerApi.putSources({
        sources: [{ website_url: websiteUrl.trim() }],
      });
      await refreshPartner();
      navigate("/partner/onboarding/media");
    } catch (err) {
      setError(err.message || "Could not save website");
    } finally {
      setSaving(false);
    }
  }

  return (
    <OnboardingStepFrame
      title="Your website"
      subtitle="Share the public URL where your programs are listed. Our developers will write a scraper and load listings into the catalog — you do not enter courses, dates, or prices here."
    >
      <form onSubmit={handleSave} className="space-y-5">
        {error && (
          <div className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{error}</div>
        )}
        <div className={sectionClass}>
          <div className="rounded-xl bg-emerald-50/80 px-4 py-3 text-sm text-emerald-900">
            After you submit, our team queues your site for setup. Going live happens only after
            listings look correct and an admin approves — not automatically.
          </div>
          <label className="block">
            <span className={labelClass}>Website URL</span>
            <input
              required
              type="url"
              className={inputClass}
              value={websiteUrl}
              onChange={(e) => setWebsiteUrl(e.target.value)}
              placeholder="https://www.yourschool.com"
            />
          </label>
        </div>
        <div className="flex flex-wrap gap-3">
          <Link
            to="/partner/onboarding/basics"
            className="rounded-lg border border-emerald-200 px-4 py-2.5 text-sm font-medium text-emerald-800 hover:bg-emerald-50"
          >
            Back
          </Link>
          <button
            type="submit"
            disabled={saving}
            className="rounded-lg bg-emerald-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-emerald-700 disabled:opacity-60"
          >
            {saving ? "Saving…" : "Save & continue"}
          </button>
        </div>
      </form>
    </OnboardingStepFrame>
  );
}
